module.exports = __webpack_public_path__ + "media/images/Vector-217fc25f.svg";